export enum Rollegruppetype {
  OPPRETTER = 'rollegruppe.oppr',
  FORPLIKTET = 'rollegruppe.forp',
  RETTIGHETSHAVER = 'rollegruppe.rett',
  ANNEN_ROLLE = 'rollegruppe.anro',
}

export const RollegruppetypeOrder: Record<Rollegruppetype, number> = {
  'rollegruppe.oppr': 0,
  'rollegruppe.forp': 1,
  'rollegruppe.rett': 2,
  'rollegruppe.anro': 3,
};
